import { render, staticRenderFns } from "./desk.vue?vue&type=template&id=eecbd498&"
import script from "./desk.vue?vue&type=script&lang=js&"
export * from "./desk.vue?vue&type=script&lang=js&"
import style0 from "./desk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports